import axios from 'axios';


// Axios request interceptor to automatically append the x-rf-user-to-assume header
// whenever a non-empty string exists in state.admin.userToAssume.
axios.interceptors.request.use((config) => {
  try {
    const userToAssume = typeof window !== 'undefined' ? (localStorage.getItem('userToAssume') || '') : '';
    if (userToAssume.trim() !== '') {
      config.headers = {
        ...config.headers,
        'x-rf-user-to-assume': userToAssume.trim(),
      } as any;
    } else if (config.headers && 'x-rf-user-to-assume' in config.headers) {
      // Remove the header if previously set but no longer needed
      delete (config.headers as any)['x-rf-user-to-assume'];
    }
  } catch (err) {
    // In case getState fails for some reason, proceed without blocking the request
    console.error('Failed to set x-rf-user-to-assume header', err);
  }
  return config;
});

export {};
